var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 33 32",
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#005ce6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.333 2h-20c-.553 0-1 .447-1 1v26c0 .553.447 1 1 1h20c.554 0 1-.447 1-1V3c0-.553-.446-1-1-1zm-8.125 2.25h3v6.56l-1.453-1.06-1.547 1.106zM7.583 27.75V4.25h8.75v9.278a.498.498 0 00.79.406l2.62-1.871 2.544 1.856a.501.501 0 00.794-.403V4.25h2v23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.208 10.81V4.25h-3v6.606l1.547-1.106z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.08 4.25v9.266a.501.501 0 01-.793.403l-2.544-1.857-2.619 1.872a.498.498 0 01-.79-.406V4.25h-8.75v23.5H25.08V4.25z",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.8941c90f2e3838b896d0ae8d39af2dd0.svg";
export { ForwardRef as ReactComponent };